import React ,{useEffect} from 'react';
import AOS from 'aos';
import Header from '../Components/Shared/Header/Header';
import Footer from '../Components/Shared/Footer/Footer';
import Container from '../Components/Pages/Privacy/Container';

function Privacy(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header styles="scrolled"/>
        <Container />
        <Footer />
        </>
    )
};
export default Privacy;